<div class="input-city" [ngClass]="customClasses">
  <input
    toggle
    type="search"
    class="input-city__toggle"
    [placeholder]="placeholder"
    [formControl]="control"
    [value]="searchQuery"
    (focus)="onFocus()"
    (input)="onSearch($event)"
    (blur)="isDropdownVisible = false"
  />
  <ngx-simplebar class="input-city__dropdown" *ngIf="isDropdownVisible">
    <ul class="input-city__list">
<!--      (click)="onSelect(result)"-->
      <li
        class="input-city__result"
        *ngFor="let result of searchResults"
      >
<!--        <span [innerHTML]="highlightMatch(result.city, searchQuery)"></span>,-->
<!--        <span [innerHTML]="highlightMatch(result.state, searchQuery)"></span>-->
      </li>
      <li *ngIf="searchResults.length === 0" class="input-city__result">
        Нет результатов
      </li>
    </ul>
  </ngx-simplebar>
</div>
